import Cookies from 'js-cookie';
import { v4 as uuidv4 } from 'uuid';
import { BabyNamesfaqs } from '../Constants/BabyNamesFaqs';
import { images } from '../Constants/ImageUrls';
import { branch } from '../Constants/branchUrls';
import { getDefaultBuildToken } from '../appconfig';
import HMAC256 from 'crypto-js/hmac-sha256';
import { getWebUserType } from './getWebUserType';

export const getUserIsLoggedIn = () => {
  if (Cookies.get('token')) {
    return true;
  } else {
    return false;
  }
};

export const getCartItems = () => {
  let r = Cookies.get('cart_items');
  if (r)
    return Cookies.get('cart_items')
      .split(',')
      .map((x) => {
        return +x;
      });
  return [];
};

export const getString = (string) => {
  const value = string?.match(/\(([^()]*)\)/)[1];
  return value;
};

export const isProductionServer = () => {
  const appType = process.env.NEXT_PUBLIC_APP_TYPE;
  return appType === 'production';
};

export function getSkuType(type) {
  let skutype = '';
  if (type == '1') {
    skutype = 'shop_product';
  } else if (type == '2') {
    skutype = 'mylo_expert_video_consultation';
  } else if (type == '3') {
    skutype = 'lead collection';
  } else if (type == '4') {
    skutype = 'LAB TEST';
  } else if (type == '5') {
    skutype = 'packages';
  } else if (type == '6') {
    skutype = 'survey';
  }
  return skutype;
}

export const checkProductLength = (productName) => {
  if (productName) {
    if (productName.length > 30) {
      return productName.substr(0, 28) + '..';
    } else {
      return productName;
    }
  }
};

export const checkStringLimit = (productName) => {
  if (productName) {
    if (productName.length > 99) {
      return productName.substr(0, 99);
    } else {
      return productName;
    }
  }
};

export const getUserToken = (tokenRequired = false) => {
  if (
    (typeof window === 'undefined' || tokenRequired) &&
    !Cookies.get('token')
  ) {
    return `Bearer ${getDefaultBuildToken()}`;
  }
  if (Cookies.get('token')) {
    return `Bearer ${Cookies.get('token')}`;
  } else {
    return null;
  }
};
export const getIsCouponExist = () => {
  if (Cookies.get('coupon')) {
    return Cookies.get('coupon');
  }
};
export const convertToQuery = (params) => {
  deleteNullKeys(params);
  const qs = Object.keys(params)
    .map((key) => `${key}=${params[key]}`)
    .join('&');
  return qs;
};
export const convertToObj = (queryInDeepLink) => {
  let obj = {};
  for (let entry of queryInDeepLink?.split('&')) {
    let pair = entry.split('=');
    obj[pair[0]] = pair[1];
  }
  return obj;
};
export const deleteNullKeys = (obj) => {
  for (const property in obj) {
    if (obj[property] == null) {
      delete obj[property];
    }
  }
};

export function isAndroidAppUser() {
  if (typeof window != 'undefined')
    return window &&
      window['mylo_android'] &&
      window['mylo_android'].getUserData
      ? true
      : false;
}

export function isAdOnForUser() {
  if (typeof window != 'undefined')
    return (
      window &&
      window['mylo_android'] &&
      (window['mylo_android']['isAdOnForUser']
        ? window['mylo_android'].isAdOnForUser()
        : false)
    );
}

export function isIOSAppUser() {
  if (typeof window != 'undefined')
    return window &&
      window['webkit'] &&
      window['webkit'].messageHandlers &&
      window['webkit']?.messageHandlers?.getUserData
      ? true
      : false;
}

export const getAlphabets = () => {
  let alphabets = [];
  for (let k = 65; k < 91; k++) {
    let str = String.fromCharCode(k);
    alphabets.push(str);
  }
  return alphabets;
};
export const generateOtp = () => {
  let val = Math.floor(1000 + Math.random() * 9000);
  return val;
};

export const cities = [
  'new-delhi',
  'hyderabad',
  'navi-mumbai',
  'kolkata',
  'varanasi',
  'bengaluru',
  'noida',
  'chennai',
  'pune',
  'mumbai',
  'gurgaon',
  'indore',
  'panchkula',
];
export const getPaths = () => {
  let paths = [];
  cities.map((city) => {
    paths.push({ params: { city: `ivf-centers-in-${city}` } });
  });
  return paths;
};
export const cityObj = {
  'new-delhi': 'New Delhi',
  'hyderabad': 'Hyderabad',
  'navi-mumbai': 'Navi Mumbai',
  'kolkata': 'Kolkata',
  'varanasi': 'Varanasi',
  'bengaluru': 'Bengaluru',
  'noida': 'Noida',
  'chennai': 'Chennai',
  'pune': 'Pune',
  'mumbai': 'Mumbai',
  'gurgaon': 'Gurgaon',
  'indore': 'Indore',
  'panchkula': 'Panchkula',
};
export const getCity = (key) => {
  return cityObj[key];
};
export const getKeyByValue = (object, value) => {
  return Object.keys(object).find((key) => object[key] === value);
};

export const getScreenName = () => {
  let currentPath = '/';
  if (typeof window != 'undefined') {
    currentPath = window.location.pathname;
  }
  // let isPdpPage = currentPath.split("/")[3] == null;
  switch (true) {
    case currentPath.includes('/store/order'):
      return 'Order Success Page';
    case currentPath.includes('/Increase-Breast-Milk'):
    case currentPath.includes('/lactomama-lactation-granules'):
      return 'Lactomama_page';
    case currentPath.includes('/reusable-cloth-diapers'):
    case currentPath.includes('/Day-And-Night'):
      return 'ClothDiaper_page';
    case currentPath.includes('/stretch-marks'):
      return 'StretchMarks_page';
    case currentPath.includes('/Celebrate-Breast-feeding'):
      return 'Celebrate_Breast_feeding_page';
    case currentPath.includes('/category'):
      return 'Category Page';
    case currentPath.includes('/address/'):
    case currentPath.includes('/changeaddress'):
      return 'Address Page';
    case currentPath.includes('/store/happytuesday'):
      return 'tuesday_sale';
    case currentPath.includes('/payment'):
      return 'payment_page';
    case currentPath.includes('/store/'):
    case currentPath.includes('/veda/'):
    case currentPath.includes('/care/'):
    case currentPath.includes('/essentials/'):
    case currentPath.includes('/product/'):
      return 'PDP';
    case currentPath.includes('/expert-profile/'):
      return 'Expert Page';
    case currentPath === '/':
      return 'Store';
    case currentPath === '/home':
      return 'Knowledge';
    case currentPath === '/community':
      return 'Community';
    case currentPath === '/taglist':
      return 'Tag List';
    case currentPath === '/clinic':
      return 'Clinic Home';
    case currentPath.includes('/clinic/'):
      return 'Clinic Pdp';
    case currentPath === '/parenting/babynames':
      return 'baby_names_tool';
    case currentPath === '/parenting/babynames/savedNames':
      return 'saved_baby_name_page';
    case currentPath.includes('/babynames/meaning-of-'):
      return 'baby_name_detail_page';
    case currentPath.includes('/babynames'):
      return 'baby_name_search_result_page';
    case currentPath.includes('parenting'):
      return 'Parenting page';
    case currentPath.includes('/pregnancy-planning'):
      return 'Ttc stage page';
    case currentPath.includes('/pregnancy'):
      return 'Pregnancy stage page';
    case currentPath.includes('/toddler'):
      return 'Toddler stage page';
    case currentPath.includes('/infant'):
      return 'Infant stage page';
    case currentPath.includes('/topic/'):
      return 'Topic Detail Page';
    case currentPath.includes('/video/'):
      return 'Video Detail Page';
    case currentPath.includes('/article'):
      return 'Article Detail Page';
    case currentPath.includes('/question'):
      return 'Questions Page';
    case currentPath === '/health':
      return 'Health Page';
    case currentPath.includes('/store'):
      return 'STORE_HOME';
    case currentPath.includes('/veda'):
      return 'VEDA_HOME';
    case currentPath.includes('/care'):
      return 'CARE_HOME';
    case currentPath.includes('/essentials'):
      return 'ESSENTIALS_HOME';
    case currentPath.includes('/ovulation'):
      return 'Ovulation Calculator Page';
    case currentPath.includes('/tools'):
      return 'TOOLS_PAGE';
    case currentPath.includes('/topics'):
      return 'TOPICS_PAGE';
    case currentPath.includes('/address'):
      return 'Address Page';
    case currentPath.includes('/changeaddress'):
      return 'Select Address Page';
    case currentPath.includes('/search'):
      return 'search_result';
    case currentPath.includes('/health/ivf-treatment'):
      return 'ivf_static_next';
    case currentPath.includes('/reviews/'):
      return 'All reviews page';
    case currentPath.includes('/login'):
      return 'Login Page';
    case currentPath.includes('/results'):
      return 'Assessment Result Page';
    case currentPath.includes('/form'):
      return 'Form Page';
    case currentPath.includes('/need-help'):
      return 'Need Help Page';
    case currentPath.includes('/my-refunds'):
      return 'My Refund Page';

    case currentPath.includes('/squishmallow'):
      return 'Squishmallow Coloring Pages';
    case currentPath.includes('/barbie'):
      return 'Barbie Coloring Pages';
    case currentPath.includes('/princess-peach'):
      return 'Princess Peach Coloring Pages';
    case currentPath.includes('/sonic'):
      return 'Sonic Coloring Pages';
    case currentPath.includes('/rainbow-friends'):
      return 'Rainbow Friends Coloring Page';
    case currentPath.includes('/coloring'):
      return 'Coloring Page';
    case currentPath.includes('/joyful-days'):
      return 'Joyful Days';
    default:
      return 'Other';
  }
};

export const showOTIAB = () => {
  return false;
};

export const replaceUnderscore = (elem) => {
  if (elem?.includes('-')) {
    return elem.replace('-', '_');
  } else {
    return elem;
  }
};
export const replacePriceSymbol = (elem) => {
  let price = elem;
  if (!isNaN(elem)) {
    price = JSON.stringify(elem);
  }
  if (price?.includes('₹')) return JSON.parse(price.replace('₹', ''));
  else return price;
};

// export const getWeb10PercentUsers = () => {
//     let in_10_Percent_Category = "";
//     if (!Cookies.get("in10PercentCategory")) {
//         in_10_Percent_Category = Math.abs(Math.floor(1 + Math.random() * 10)) == 1 ? "true" : "false";
//         Cookies.set("in10PercentCategory", in_10_Percent_Category, "/");
//     } else {
//         if (Cookies.get("in10PercentCategory")) {
//             in_10_Percent_Category = JSON.parse(Cookies.get("in10PercentCategory"));
//         }
//     }
//     return in_10_Percent_Category;
// };
export const getDeviceType = () => {
  const Device =
    typeof window != 'undefined' && window.screen.availWidth > 720
      ? 'desktop'
      : 'mWeb';
  return Device;
};
export const getBranchLink = () => {
  const storeUrls = [
    '/store',
    '/category',
    '/store/product',
    '/store/productv2',
    '/essentials',
    '/care',
    '/veda',
  ];
  const communityUrls = [
    '/about-mylo',
    '/category',
    '/community',
    '/partner-with-us',
    '/privacy-policy',
    '/refund-cancellation',
    'taglist',
  ];
  const toolUrls = ['/explore', '/babynames', '/tools'];
  const healthUrls = ['/health'];
  const topicUrls = ['/topic/'];
  const questionUrls = ['/question/'];
  const articleUrls = ['/article/'];
  let currentPath = '/';
  if (typeof window != 'undefined') {
    currentPath = window.location.pathname;
  }

  switch (true) {
    case currentPath === '/':
      // console.log("Main Landing Page")
      return branch.CQWrmUBP1lb;
    case containUrls(currentPath, topicUrls):
      // console.log("Tools Landing_Page")
      return branch.h8smrsgNtnb;
    case containUrls(currentPath, questionUrls):
      // console.log("Tools Landing_Page")
      return branch.dhnHHAoNtnb;
    case containUrls(currentPath, articleUrls):
      // console.log("Tools Landing_Page")
      return branch.SBvwKlNtnb;
    case containUrls(currentPath, toolUrls):
      // console.log("Tools Landing_Page")
      return branch.reqF5mGP1lb;
    case containUrls(currentPath, healthUrls):
      // console.log("Health Page")
      return branch.pn9Rz6EP1lb;
    case containUrls(currentPath, storeUrls):
      // console.log("Store Page")
      return branch.mqQdQPxP1lb;
    case containUrls(currentPath, communityUrls):
      // console.log("Community Page")
      return branch.jgTtsHDP1lb;
    default:
      // console.log("DEFAULT")//Community
      return branch.jgTtsHDP1lb;
  }
};
export const containUrls = (searchObject, array) => {
  for (let i = 0; i < array.length; i++) {
    if (searchObject.includes(array[i])) {
      return true;
    }
  }
  return false;
};

export const getCategoryKey = (category) => {
  let id = category?.split('-')?.pop() || category;
  return id;
};

export const setOfferUserType = (priceType) => {
  Cookies.set('offer_user_type', priceType);
};

export const getPriceType = () => {
  const params = new URLSearchParams(window.location.search);
  const priceType = params.get('type') || '';
  setOfferUserType(priceType);
  return priceType;
};

export const getProductBrandSeparateUrl = (completeUrl) => {
  if (!completeUrl) {
    return [];
  }
  const url = completeUrl?.split('/');
  const [, brand, webUrl] = url;
  return [brand, webUrl];
};

export const removeDefaultParams = (queryObject) => {
  const modifiedObj = { ...queryObject };
  keysToRemove.forEach((elm) => {
    delete modifiedObj[elm];
  });
  return modifiedObj;
};
export const keysToRemove = [
  'brand',
  'categoryname',
  'product',
  'articleId',
  'id',
  'questionId',
  'subcategory',
  'week',
  'videoId',
  'name',
  'page',
  'search',
  'gender',
  'startingWith',
  'religion',
  'origin',
  'mostViewed',
  'q',
  'tag',
  'birth',
  'popup',
  'topicPage',
  'clinicPage',
  'parentingPage',
  'packageName',
  'key',
  'sku_ids',
  'daiper',
  'productId',
  'category',
  'variant',
];

export const showNewCartFlow = () => {
  // return getWebUserType() == "A";
  return true;
};

export const cartPopupFlow = () => {
  return false;
  return getWebUserType() == 'B';
};

export function createRippleEffectRelative(event, element, color) {
  const button = event.currentTarget;

  const circle = document.createElement('span');
  const diameter = Math.max(button.clientWidth, button.clientHeight);
  const radius = diameter / 2;

  circle.style.width = circle.style.height = `${diameter}px`;
  circle.style.left = `${event.clientX - button.offsetLeft - radius}px`;
  circle.style.top = `${
    event.clientY - element.getBoundingClientRect().top - radius
  }px`;
  circle.classList.add(color === 'black' ? 'rippleBlack' : 'ripple');

  const ripple = button.getElementsByClassName(
    color === 'black' ? 'rippleBlack' : 'ripple',
  )[0];

  if (ripple) {
    ripple.remove();
  }

  button.appendChild(circle);
}

export const getContentType = () => {
  const screenName = getScreenName();
  let contentType = '';
  switch (screenName) {
    case 'Knowledge':
    case 'Community':
      contentType = 'community_home_page';
      break;
    case 'Topic Detail Page':
      contentType = 'topic_detail_page';
      break;
    case 'Video Detail Page':
      contentType = 'video_detail_page';
      break;
    case 'Article Detail Page':
      contentType = 'article_detail_page';
      break;
    case 'Questions Page':
      contentType = 'question_detail_page';
      break;
    case 'Parenting page':
      contentType = 'parenting_page';
      break;
    case 'Ttc stage page':
    case 'Infant stage page':
    case 'Toddler stage page':
    case 'Pregnancy stage page':
      contentType = 'stage_page';
      break;
  }
  return contentType;
};

export const checkAndScrollSectionToViewPort = (
  targetSectionRef,
  scrollSectionRef,
  offset = 0,
) => {
  const targetSection = targetSectionRef.current;
  const targetRect = targetSection?.getBoundingClientRect();
  const scrollSection = scrollSectionRef.current;
  const containerRect = scrollSection?.getBoundingClientRect();
  if (targetRect && containerRect) {
    const isInViewport =
      targetRect.top >= containerRect.top &&
      targetRect.left >= containerRect.left &&
      targetRect.bottom <= containerRect.bottom &&
      targetRect.right <= containerRect.right;
    if (!isInViewport) {
      scrollSection.scrollTo(
        0,
        targetSection.offsetTop - scrollSection.clientHeight + offset,
      );
    }
  }
};

export const getMonthName = (monthName) => {
  switch (monthName) {
    case 1:
      return 'January';
    case 2:
      return 'February';
    case 3:
      return 'March';
    case 4:
      return 'April';
    case 5:
      return 'May';
    case 6:
      return 'June';
    case 7:
      return 'July';
    case 8:
      return 'August';
    case 9:
      return 'September';
    case 10:
      return 'October';
    case 11:
      return 'November';
    case 12:
      return 'December';
    default:
      break;
  }
};
export const questionPageStaticTopics = [
  {
    description: 'Baby Shower',
    web_url: '/topic/baby-shower-4201',
  },
  {
    description: 'White Discharge',
    web_url: '/topic/white-discharge-4532',
  },
  {
    description: 'Ovulation',
    web_url: '/topic/ovulation-4370',
  },
  {
    description: 'Breastfeeding & Lactation',
    web_url: '/topic/breastfeeding-lactation-4571',
  },
  {
    description: 'Miscarriage',
    web_url: '/topic/miscarriage-423',
  },
  {
    description: 'Scans & Tests',
    web_url: '/topic/scans-tests-4247',
  },
];
export const getCategoryBrandSeperateUrl = (completeUrl) => {
  if (!completeUrl) {
    return [];
  }
  const url = completeUrl?.split('/');
  const [category, _, webUrl] = url;
  return [category, webUrl];
};

export const CheckAppInstalledOrNot = async () => {
  try {
    const value = await navigator
      .getInstalledRelatedApps()
      .then((relatedApps) => {
        // console.log("relatedApps", relatedApps);
        if (relatedApps.length > 0) {
          return true;
        } else {
          return false;
        }
        // relatedApps?.forEach((app) => {
        //     console.log(app.id, app.platform, app.url);
        // })
      })
      .catch((error) => {
        // console.log("error", error);
      });
    return value;
  } catch (error) {
    // console.log("getInstalledRelatedApps not found", error);
  }
};
export const getToolsArrayAndLength = (
  toolsData,
  currentToolId,
  // pregnantToolCount,
  // motherToolCount,
) => {
  let toolsarray = [];
  toolsData?.map((toolTitle) => {
    toolTitle?.tools.map((tools) => {
      if (
        tools?.value &&
        (tools?.type == 1 || tools?.id == 52) &&
        tools?.id != currentToolId &&
        tools?.id != 12 // dpn't show nakshatra calculatore
      ) {
        toolsarray.push(tools);
      }
    });
  });
  let toolsLength = toolsarray?.length;
  return { toolsarray, toolsLength };
};
export const capitalizeFirstLetter = (s) => {
  if (typeof s !== 'string') return '';
  return s.charAt(0).toUpperCase() + s.slice(1);
};

export const scrollToTargetAdjusted = (element, offset) => {
  const elementPosition = element.getBoundingClientRect().top;
  const offsetPosition = elementPosition + window.pageYOffset - offset;
  window.scrollTo({
    top: offsetPosition,
    behavior: 'smooth',
  });
};

export const salt = `4z432688-vxdr-14ca-vsd2-3427kr532sdw3`;
export const encryptDataSHA = (data) => {
  return HMAC256(JSON.stringify(data), salt);
};

export const getEncryptedData = (mobile, otp, expires) => {
  // const object = { mobile: mobile, otp: otp };
  const data = `${mobile}.${otp}.${expires}`;
  // console.log("Object: " + data);
  return encryptDataSHA(JSON.stringify(data)).toString();
};
export const isWhiteColor = (...args) => {
  return args.every((color) => {
    return (
      color == '#ffffff' || color == 'white' || color == 'rgb(255 255 255)'
    );
  });
};
export const getRandomEventId = () => {
  const randomNumber = uuidv4();
  const EventId = `event${randomNumber}`;
  return EventId;
};

export const showVideoAccToUserType = (videoData) => {
  return videoData?.length;
};

export const getVideoThumbnail = (URL) => {
  let url = URL?.split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/|\/shorts\/)/);
  let id = url?.[2] !== undefined ? url[2].split(/[^0-9a-z_\-]/i)[0] : url[0];
  return `https://img.youtube.com/vi/${id}/hqdefault.jpg`;
};

export const getVideoUrl = (URL, autoPlay, muted) => {
  let url = URL.split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/|\/shorts\/)/);
  let id = url[2] !== undefined ? url[2].split(/[^0-9a-z_\-]/i)[0] : url[0];
  return `https://www.youtube.com/embed/${id}?autoplay=${autoPlay}&loop=1&autopause=0&mute=${muted}&enablejsapi=1&fs=0&rel=0`;
};
export const getVideoUrlIframe = (URL, autoPlay, mute) => {
  let url = URL.split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/|\/shorts\/)/);
  let id = url[2] !== undefined ? url[2].split(/[^0-9a-z_\-]/i)[0] : url[0];
  return `https://www.youtube.com/embed/${id}?autoplay=${autoPlay}&loop=1&autopause=0&mute=${mute}&enablejsapi=1&fs=0&rel=0`;
};
export const getVideoUrlIframeNoControl = (URL) => {
  let url = URL.split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/|\/shorts\/)/);
  let id = url[2] !== undefined ? url[2].split(/[^0-9a-z_\-]/i)[0] : url[0];
  return `https://www.youtube.com/embed/${id}?autoplay=1&loop=1&autopause=0&mute=0&enablejsapi=1&fs=0&rel=0&controls=0&modestbranding=1&iv_load_policy=3&playsinline=1&showInfo=0`;
};
export const intToString = (value) => {
  if (value > 1000) {
    let suffixe = 'k';
    let shortValue = parseFloat((value / 1000).toPrecision(2));
    if (shortValue % 1 != 0) {
      shortValue = shortValue.toFixed(1);
    }
    return shortValue + suffixe;
  }
  return value;
};
export const getDestinationUrl = (data, url) => {
  let arrayLength = data?.length;
  for (let i = 0; i < arrayLength; i++) {
    if (data[i]?.id == url) {
      return data[i]?.web_url;
    }
  }
};
export const getEncodedUrl = (str) => {
  let finalUrl = str?.split('/');
  let length = finalUrl?.length;
  finalUrl[length - 1] = encodeURIComponent(finalUrl[length - 1]);
  return finalUrl.join('/');
};
export const PregnancyTopicsData = [
  {
    image: images.is_it_normal,
    description: 'TRIMESTER I',
    web_url: '/topic/is-it-normal-4123',
    items: [
      {
        description: 'Is it Normal?',
        term_id: 4123,
        web_url: '/topic/is-it-normal-4123',
      },
      {
        description: 'Nausea & Vomiting',
        term_id: 4295,
        web_url: '/topic/nausea-vomiting-tips-4295',
      },
      {
        description: 'Back Pain',
        term_id: 4312,
        web_url: '/topic/back-pain-4312',
      },
      {
        description: 'Breast Changes',
        term_id: 512,
        web_url: '/topic/breast-changes-512',
      },
    ],
  },
  {
    image: images.food_cravings,
    description: 'TRIMESTER II',
    web_url: '/topic/food-cravings-4305',
    items: [
      {
        description: 'Food Cravings',
        term_id: 4305,
        web_url: '/topic/food-cravings-4305',
      },
      {
        description: 'Heartburn',
        term_id: 4301,
        web_url: '/topic/heartburn-4301',
      },
      // { description: "Pregnancy Diet Chart", id: 4645 },
      {
        description: 'Fetal Movements',
        term_id: 4233,
        web_url: '/topic/fetal-movements-4233',
      },
      // { description: "Sleeping Problems", id: 4514 },
    ],
  },
  {
    image: images.labour_birth,
    description: 'TRIMESTER III',
    web_url: '/topic/labour-birth-4127',
    items: [
      {
        description: 'Labour & Delivery',
        term_id: 4127,
        web_url: '/topic/labour-birth-4127',
      },
      {
        description: 'Contractions',
        term_id: 4263,
        web_url: '/topic/contractions-4263',
      },
      {
        description: 'Leg Cramps',
        term_id: 4298,
        web_url: '/topic/leg-cramps-4298',
      },
    ],
  },
];

// export const showBogoOfferFlowAccToPage = () => {
//     let currentPath = window.location.pathname;
//     let key = currentPath.split("/")[2];
//     let showNewFlow = false;
//     switch (key) {
//         case "happytuesday":
//         case "clothdiapers":
//         case "summerstore":
//         case "bogo":
//         case "reusable-cloth-diapers-5433":
//             showNewFlow = true;
//             break;
//         default:
//             showNewFlow = false;
//             break;
//     }
//     return showNewFlow;
// };
const questions = [
  'What are some of the most unique names starting with',
  'What is a cute name that starts with',
  'What Bible name starts with an',
  'What middle name starts with an',
  'What is the longest name beginning with',
  'What is the shortest name beginning with',
];
const answers = [
  'are a few unique names starts with',
  'are a few cute names that starts with',
  'are Bible names that starts with',
  'are a few middle names that starts with',
  'is the longest name beginning with',
  'are some of the shortest names beginning with',
];

export const fetchBabyNamesFAQData = (letter) => {
  let newContent = `
    <p>
    <strong>FAQs</strong>
    </p>
    <p>
    <strong>&nbsp;</strong>
    </p>
`;
  const letterData = BabyNamesfaqs[letter];
  let currentQuestion = 1;
  questions.map((question, index) => {
    if (letterData[index].length > 0) {
      let names = letterData[index].reduce(
        (acc, current) =>
          (acc +=
            ` ` +
            `<a target="_blank" href="/parenting/babynames/meaning-of-${current.name?.toLowerCase()}-${
              current.id
            }">${current.name}</a>` +
            ' ,'),
        '',
      );
      names = names.substring(0, names.length - 1);
      newContent += '<p>&nbsp;</p>';
      newContent += `<p>${currentQuestion}. ${question} ${letter}?&nbsp;</p>
             <p>
             Ans - ${names} ${answers[index]} ${letter}&nbsp;.
            </p>`;
      currentQuestion++;
    }
  });
  return newContent;
};

export const getJsonLdData = (letter) => {
  const FAQs = [];
  const letterData = BabyNamesfaqs[letter];
  questions.map((question, index) => {
    if (letterData[index].length > 0) {
      let names = letterData[index].reduce(
        (acc, current) => (acc += ` ` + `${current.name}` + ' ,'),
        '',
      );
      names = names.substring(0, names.length - 1);
      let questionName = `${question} ${letter}?`;
      let acceptedAnswerText = `${names} ${answers[index]} ${letter}.`;
      FAQs.push({
        questionName,
        acceptedAnswerText,
      });
    }
  });
  return FAQs;
};

export const getPathForBabyNames = (path, detailPage, dynamicKey) => {
  if (detailPage) {
    return path + dynamicKey;
  }
  return 'babynames/' + path + dynamicKey;
};

export const getSelectedLanguage = (pathSplit) => {
  switch (pathSplit[1]) {
    case 'hi':
      return 'हिन्दी';
    case 'bn':
      return 'বাঙ্গালী';
    default:
      return 'English';
  }
};

export const getFilteredCategoryContent = (categoryData) => {
  const getObject = (element) => {
    return {
      tabName: element.tabName || null,
      key: element.key || null,
      icon: element.icon || null,
      mobileWebIcon: element.mobileWebIcon || null,
      subCategories: returnSubCategories(element.subCategories) || null,
      _id: element._id || null,
      productData: element?.productData || null,
      articleData: element?.articleData || null,
      image: element?.image || null,
      totalProducts: element?.totalProducts || null,
      tabDescription: element?.tabDescription || null,
      tabIcon: element?.tabIcon || null,
    };
  };
  const returnSubCategories = (subCategories) => {
    return subCategories?.map((element) => {
      return getObject(element);
    });
  };
  const data = categoryData?.map((element) => {
    return getObject(element);
  });
  return data;
};

export const getSubCategoryFilter = (categoryData, isL0Category) => {
  // if (!isL0Category) return categoryData || [];
  const filteredData = [];
  const showKeys = [
    'deepLink',
    'key',
    'tabName',
    'icon',
    'mobileWebIcon',
    'smart_icon',
    '_id',
    'avg_rating',
    'starRatingSubScript',
  ];
  const itemKeys = [
    'web_url',
    'image',
    'tabName',
    'nickname',
    'price',
    'strikePrice',
    'avg_rating',
    'starRatingSubScript',
    'textFlag',
    'priceA',
    'priceB',
  ];
  categoryData?.map((data, index) => {
    showKeys?.map((key) => {
      if (!filteredData[index]) filteredData[index] = {};
      filteredData[index][key] = data[key] || null;

      if (data.items) {
        filteredData[index]['items'] = filterKeys(data.items, itemKeys);
      }
    });
  });
  return filteredData;
};

export const filterKeys = (obj, keys) => {
  return obj?.map((item) => {
    const filterObj = {};
    keys?.map((key) => {
      filterObj[key] = item[key] || null;
    });
    return filterObj;
  });
};

export const getFilteredCategoryData = (categoryData, isL0Category) => {
  if (!isL0Category) return categoryData;
  const reqdKeys = [
    'footnote',
    'updatedOn',
    'reviewTable',
    'alsoSearchFor',
    'priceTable',
    'footNoteFaqs',
    'tabName',
    'metaTitle',
    'metaDescription',
    'sectionBgImageDesktop',
    'sectionBgImageMobileWeb',
    'deeplink',
  ];
  const newCategoryData = { data: {} };
  reqdKeys?.map((key) => {
    newCategoryData['data'][key] = categoryData.data[key] || null;
  });
  newCategoryData['data']['items'] = categoryData['data'['items']] || null;
  return newCategoryData;
};

export const getSimilarData = (similarElements, type) => {
  let data = null;
  if (similarElements?.length > 0) {
    similarElements?.forEach((element) => {
      switch (element?.data[0]?.type) {
        case type:
          data = element?.data;
        default:
          break;
      }
    });
  }
  return data;
};

export const getDiscussionJSONLdData = (discussionData) => {
  let DiscussionJSONLDData = [];
  discussionData?.data?.content?.map((element) => {
    let obj = {
      questionName: element?.content?.message ? element?.content?.message : '',
      acceptedAnswerText: element?.content?.commentData[0]?.message
        ? element?.content?.commentData[0]?.message
        : '',
    };
    DiscussionJSONLDData.push(obj);
  });
  return DiscussionJSONLDData;
};
export const getReviewJSONLdData = (reviewDataData) => {
  let ReviewJSONData = [];
  let content = [];
  reviewDataData?.data?.content?.map((item, index) => {
    let obj = {
      username: item?.content?.user_details?.username
        ? item?.content?.user_details?.username
        : '',
      title: item?.content?.title ? item?.content?.title : '',
      reviewRating: {
        bestRating: '5',
        ratingValue: item.rating ? item.rating : '',
        worstRating: '1',
      },

      positiveNotes: {
        '@type': 'ItemList',
        'itemListElement': [
          {
            '@type': 'ListItem',
            'position': index + 1,
            'name': item?.content?.title,
          },
        ],
      },
      negativeNotes: {
        '@type': 'ItemList',
        'itemListElement': [
          {
            '@type': 'ListItem',
            'position': index + 1,
            'name': item?.content?.title,
          },
        ],
      },
    };

    let contentObject = {
      content: {
        body: item?.content?.body ? item?.content?.body : '',
        created_at: item?.content?.created_at ? item?.content?.created_at : '',
        user_details: item?.content?.user_details
          ? item?.content?.user_details
          : '',
        webpImages: item?.content?.webpImages ? item?.content?.webpImages : '',
        propertytags: item?.content?.propertytags
          ? item?.content?.propertytags
          : '',
        title: item?.content?.title ? item?.content?.title : '',
      },
      helpful_counts: item?.helpful_counts ? item?.helpful_counts : '',
      id: item?.id ? item?.id : '',
      rating: item?.rating ? item?.rating : '',
    };
    content.push(contentObject);
    ReviewJSONData.push(obj);
  });
  return { ReviewJSONData, content };
};
export const getProductData = (data) => {
  let obj = {};
  let similarProductWeb = [];
  data?.similarProductWeb?.map((element) => {
    obj = {
      web_url: element?.web_url,
      id: element?.id,
      name: element?.name,
      showImage: element?.showImage,
      rating_count: element?.rating_count,
      avg_rating: element?.avg_rating,
      price: element?.price,
      strikeprice: element?.strikeprice,
    };
    similarProductWeb.push(obj);
  });
  data['similarProductWeb'] = similarProductWeb;
  data['similarProduct'] = {};
  return data;
};

export const isPdpOrCategoryPage = (router) => {
  if (
    router?.pathname.includes('category') ||
    router?.asPath.includes('/store/') ||
    router?.asPath.includes('/veda/') ||
    router?.asPath.includes('/care/') ||
    router?.asPath.includes('/essentials/') ||
    router?.pathname === '/'
  ) {
    return true;
  }
  return false;
};
export const generateTimeString = (created_at) => {
  const actualDate = new Date(created_at);
  const month = monthMapping[actualDate.getUTCMonth()];
  const monthNo = actualDate.getUTCMonth();
  const day = actualDate.getUTCDate();
  const year = actualDate.getUTCFullYear();
  const date = new Date(actualDate);
  const currentDate = new Date();
  const dayDiff = Math.abs(
    (currentDate.getTime() - date.getTime()) / (1000 * 60 * 60 * 24),
  );
  const elapsedDays = Math.floor(dayDiff);
  return { day, elapsedDays, month, year, monthNo };
};

export const monthMapping = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];
export const countryMappingCode = [
  {
    code: 'AF',
    name: 'Afghanistan',
  },
  {
    code: 'AX',
    name: 'Resland Islands',
  },
  {
    code: 'AL',
    name: 'Albania',
  },
  {
    code: 'DZ',
    name: 'Algeria',
  },
  {
    code: 'AS',
    name: 'American Samoa',
  },
  {
    code: 'AD',
    name: 'Andorra',
  },
  {
    code: 'AO',
    name: 'Angola',
  },
  {
    code: 'AI',
    name: 'Anguilla',
  },
  {
    code: 'AQ',
    name: 'Antarctica',
  },
  {
    code: 'AG',
    name: 'Antigua and Barbuda',
  },
  {
    code: 'AR',
    name: 'Argentina',
  },
  {
    code: 'AM',
    name: 'Armenia',
  },
  {
    code: 'AW',
    name: 'Aruba',
  },
  {
    code: 'AU',
    name: 'Australia',
  },
  {
    code: 'AT',
    name: 'Austria',
  },
  {
    code: 'AZ',
    name: 'Azerbaijan',
  },
  {
    code: 'BS',
    name: 'Bahamas',
  },
  {
    code: 'BH',
    name: 'Bahrain',
  },
  {
    code: 'BD',
    name: 'Bangladesh',
  },
  {
    code: 'BB',
    name: 'Barbados',
  },
  {
    code: 'BY',
    name: 'Belarus',
  },
  {
    code: 'BE',
    name: 'Belgium',
  },
  {
    code: 'BZ',
    name: 'Belize',
  },
  {
    code: 'BJ',
    name: 'Benin',
  },
  {
    code: 'BM',
    name: 'Bermuda',
  },
  {
    code: 'BT',
    name: 'Bhutan',
  },
  {
    code: 'BO',
    name: 'Bolivia, Plurinational State of',
  },
  {
    code: 'BQ',
    name: 'Billion, Sint Eustatius and Saba',
  },
  {
    code: 'BA',
    name: 'Bosnia and Herzegovina',
  },
  {
    code: 'BW',
    name: 'Botswana',
  },
  {
    code: 'BV',
    name: 'Bouvet Island',
  },
  {
    code: 'BR',
    name: 'Brazil',
  },
  {
    code: 'IO',
    name: 'British Indian Ocean Territory',
  },
  {
    code: 'BN',
    name: 'Brunei Darussalam',
  },
  {
    code: 'BG',
    name: 'Bulgaria',
  },
  {
    code: 'BF',
    name: 'Burkina Faso',
  },
  {
    code: 'BI',
    name: 'Burundi',
  },
  {
    code: 'KH',
    name: 'Cambodia',
  },
  {
    code: 'CM',
    name: 'Cameroon',
  },
  {
    code: 'CA',
    name: 'Canada',
  },
  {
    code: 'CV',
    name: 'Cape Verde',
  },
  {
    code: 'KY',
    name: 'Cayman Islands',
  },
  {
    code: 'CF',
    name: 'Central African Republic',
  },
  {
    code: 'TD',
    name: 'Chad',
  },
  {
    code: 'CL',
    name: 'Chile',
  },
  {
    code: 'CN',
    name: 'China',
  },
  {
    code: 'CX',
    name: 'Christmas Island',
  },
  {
    code: 'CC',
    name: 'Cocos (Keeling) Islands',
  },
  {
    code: 'CO',
    name: 'Colombia',
  },
  {
    code: 'KM',
    name: 'Comoros',
  },
  {
    code: 'CG',
    name: 'Congo',
  },
  {
    code: 'CD',
    name: 'Congo, the Democratic Republic of the',
  },
  {
    code: 'CK',
    name: 'Cook Islands',
  },
  {
    code: 'CR',
    name: 'Costa Rica',
  },
  {
    code: 'CI',
    name: "Choose d'Ivoire",
  },
  {
    code: 'HR',
    name: 'Croatia',
  },
  {
    code: 'CU',
    name: 'Cuba',
  },
  {
    code: 'CW',
    name: 'Cura Zao',
  },
  {
    code: 'CY',
    name: 'Cyprus',
  },
  {
    code: 'CZ',
    name: 'Czech Republic',
  },
  {
    code: 'DK',
    name: 'Denmark',
  },
  {
    code: 'DJ',
    name: 'Djibouti',
  },
  {
    code: 'DM',
    name: 'Dominica',
  },
  {
    code: 'DO',
    name: 'Dominican Republic',
  },
  {
    code: 'EC',
    name: 'Ecuador',
  },
  {
    code: 'EG',
    name: 'Egypt',
  },
  {
    code: 'SV',
    name: 'El Salvador',
  },
  {
    code: 'GQ',
    name: 'Equatorial Guinea',
  },
  {
    code: 'ER',
    name: 'Eritrea',
  },
  {
    code: 'YES',
    name: 'Estonia',
  },
  {
    code: 'ET',
    name: 'Ethiopia',
  },
  {
    code: 'FK',
    name: 'Falkland Islands (Malvinas )',
  },
  {
    code: 'FO',
    name: 'Faroe Islands',
  },
  {
    code: 'FJ',
    name: 'Fiji',
  },
  {
    code: 'FI',
    name: 'Finland',
  },
  {
    code: 'FR',
    name: 'France',
  },
  {
    code: 'GF',
    name: 'French Guiana',
  },
  {
    code: 'PF',
    name: 'French Polynesia',
  },
  {
    code: 'TF',
    name: 'French Southern Territories',
  },
  {
    code: 'GA',
    name: 'Gabon',
  },
  {
    code: 'GM',
    name: 'Gambia',
  },
  {
    code: 'GE',
    name: 'Georgia',
  },
  {
    code: 'DE',
    name: 'Germany',
  },
  {
    code: 'GH',
    name: 'Ghana',
  },
  {
    code: 'GI',
    name: 'Gibraltar',
  },
  {
    code: 'GR',
    name: 'Greece',
  },
  {
    code: 'GL',
    name: 'Greenland',
  },
  {
    code: 'GD',
    name: 'Grenada',
  },
  {
    code: 'GP',
    name: 'Guadeloupe',
  },
  {
    code: 'GU',
    name: 'Guam',
  },
  {
    code: 'GT',
    name: 'Guatemala',
  },
  {
    code: 'GG',
    name: 'Guernsey',
  },
  {
    code: 'GN',
    name: 'Guinea',
  },
  {
    code: 'GW',
    name: 'Guinea-Bissau',
  },
  {
    code: 'GY',
    name: 'Guyana',
  },
  {
    code: 'HT',
    name: 'Hit',
  },
  {
    code: 'HM',
    name: 'Heard Island and McDonald Islands',
  },
  {
    code: 'VA',
    name: 'Holy See (Vatican City State )',
  },
  {
    code: 'HN',
    name: 'Honuras',
  },
  {
    code: 'HK',
    name: 'Hong Kong',
  },
  {
    code: 'HU',
    name: 'Hungary',
  },
  {
    code: 'IS',
    name: 'Iceland',
  },
  {
    code: 'IN',
    name: 'India',
  },
  {
    code: 'ID',
    name: 'Indonesia',
  },
  {
    code: 'IR',
    name: 'Iran, Islamic Republic of',
  },
  {
    code: 'IQ',
    name: 'Iraq',
  },
  {
    code: 'IE',
    name: 'Ireland',
  },
  {
    code: 'IM',
    name: 'Isle of Man',
  },
  {
    code: 'IL',
    name: 'Israel',
  },
  {
    code: 'IT',
    name: 'Italy',
  },
  {
    code: 'JM',
    name: 'Jamaica',
  },
  {
    code: 'JP',
    name: 'Japan',
  },
  {
    code: 'JE',
    name: 'Jersey',
  },
  {
    code: 'JO',
    name: 'Jordan',
  },
  {
    code: 'KZ',
    name: 'Kazakhstan',
  },
  {
    code: 'KE',
    name: 'Kenya',
  },
  {
    code: 'KI',
    name: 'Kiribati',
  },
  {
    code: 'KP',
    name: "Korea, Democratic People's Republic of",
  },
  {
    code: 'KR',
    name: 'Korea, Republic of',
  },
  {
    code: 'KW',
    name: 'Kuwait',
  },
  {
    code: 'KG',
    name: 'Kyrgyzstan',
  },
  {
    code: 'LA',
    name: "Lao People's Democratic Republic",
  },
  {
    code: 'LV',
    name: 'Latvia',
  },
  {
    code: 'LB',
    name: 'Lebanon',
  },
  {
    code: 'LS',
    name: 'Lesotho',
  },
  {
    code: 'LR',
    name: 'Liberia',
  },
  {
    code: 'LY',
    name: 'Libya',
  },
  {
    code: 'LI',
    name: 'Liechtenstein',
  },
  {
    code: 'LT',
    name: 'Lithuania',
  },
  {
    code: 'LU',
    name: 'Luxembourg',
  },
  {
    code: 'MO',
    name: 'Macao',
  },
  {
    code: 'MK',
    name: 'Macedonia, the Former Yugoslav Republic of',
  },
  {
    code: 'MG',
    name: 'Madagascar',
  },
  {
    code: 'MW',
    name: 'Malawi',
  },
  {
    code: 'MY',
    name: 'Malaysia',
  },
  {
    code: 'MV',
    name: 'Maldives',
  },
  {
    code: 'ML',
    name: 'Mali',
  },
  {
    code: 'MT',
    name: 'Malta',
  },
  {
    code: 'MH',
    name: 'Marshall Islands',
  },
  {
    code: 'MQ',
    name: 'Martinique',
  },
  {
    code: 'MR',
    name: 'Mauritania',
  },
  {
    code: 'MU',
    name: 'Mauritius',
  },
  {
    code: 'YT',
    name: 'Mayotte',
  },
  {
    code: 'MX',
    name: 'Mexico',
  },
  {
    code: 'FM',
    name: 'Micronesia, Federaled States of',
  },
  {
    code: 'MD',
    name: 'Moldova, Republic of',
  },
  {
    code: 'MC',
    name: 'Monaco',
  },
  {
    code: 'MN',
    name: 'Mongolia',
  },
  {
    code: 'ME',
    name: 'Montenegro',
  },
  {
    code: 'MS',
    name: 'Montserrat',
  },
  {
    code: 'MA',
    name: 'Morocco',
  },
  {
    code: 'MZ',
    name: 'Mozambique',
  },
  {
    code: 'MM',
    name: 'Myanmar',
  },
  {
    code: 'ON',
    name: 'Namibia',
  },
  {
    code: 'NR',
    name: 'Inside',
  },
  {
    code: 'NP',
    name: 'Nepal',
  },
  {
    code: 'NL',
    name: 'Netherlands',
  },
  {
    code: 'NC',
    name: 'New Caledonia',
  },
  {
    code: 'NZ',
    name: 'New Zealand',
  },
  {
    code: 'NI',
    name: 'Nicaragua',
  },
  {
    code: 'NE',
    name: 'Niger',
  },
  {
    code: 'NG',
    name: 'Nigeria',
  },
  {
    code: 'NU',
    name: 'Niue',
  },
  {
    code: 'NF',
    name: 'Norfolk Island',
  },
  {
    code: 'MP',
    name: 'Northern Mariana Islands',
  },
  {
    code: 'NO',
    name: 'Norway',
  },
  {
    code: 'OM',
    name: 'Oman',
  },
  {
    code: 'PK',
    name: 'Pakistan',
  },
  {
    code: 'PW',
    name: 'Palau',
  },
  {
    code: 'PS',
    name: 'Palestine, State of',
  },
  {
    code: 'PA',
    name: 'Panama',
  },
  {
    code: 'PG',
    name: 'Papua New Guinea',
  },
  {
    code: 'PY',
    name: 'Paraguay',
  },
  {
    code: 'PE',
    name: 'Peru',
  },
  {
    code: 'PH',
    name: 'Philippines',
  },
  {
    code: 'PN',
    name: 'Pitcairn',
  },
  {
    code: 'PL',
    name: 'Poland',
  },
  {
    code: 'PT',
    name: 'Portugal',
  },
  {
    code: 'PR',
    name: 'Puerto Rico',
  },
  {
    code: 'QA',
    name: 'Qatar',
  },
  {
    code: 'RE',
    name: 'Réunion',
  },
  {
    code: 'RO',
    name: 'Romania',
  },
  {
    code: 'RU',
    name: 'Russian Federation',
  },
  {
    code: 'RW',
    name: 'Rwanda',
  },
  {
    code: 'BL',
    name: 'Saint Barthélemy',
  },
  {
    code: 'SH',
    name: 'Saint Helena, Ascension and Tristan da Cunha',
  },
  {
    code: 'KN',
    name: 'Saint Kitts and Nevis',
  },
  {
    code: 'LC',
    name: 'Saint Lucia',
  },
  {
    code: 'MF',
    name: 'Saint Martin (French part)',
  },
  {
    code: 'PM',
    name: 'Saint Pierre and Miquelon',
  },
  {
    code: 'VC',
    name: 'Saint Vincent and the Grenadines',
  },
  {
    code: 'WS',
    name: 'Samoa',
  },
  {
    code: 'SM',
    name: 'San Marino',
  },
  {
    code: 'ST',
    name: 'Sao Tome and Principe',
  },
  {
    code: 'SA',
    name: 'Saudi Arabia',
  },
  {
    code: 'SN',
    name: 'Senegal',
  },
  {
    code: 'RS',
    name: 'Serbia',
  },
  {
    code: 'SC',
    name: 'Seychelles',
  },
  {
    code: 'SL',
    name: 'Sierra Leone',
  },
  {
    code: 'SG',
    name: 'Singapore',
  },
  {
    code: 'SX',
    name: 'Sint Maarten (Dutch part)',
  },
  {
    code: 'SK',
    name: 'Slovakia',
  },
  {
    code: 'SI',
    name: 'Slovenia',
  },
  {
    code: 'SB',
    name: 'Solomon Islands',
  },
  {
    code: 'SO',
    name: 'Somalia',
  },
  {
    code: 'ZA',
    name: 'South Africa',
  },
  {
    code: 'GS',
    name: 'South Georgia and the South Sandwich Islands',
  },
  {
    code: 'SS',
    name: 'South Sudan',
  },
  {
    code: 'ES',
    name: 'Spain',
  },
  {
    code: 'LK',
    name: 'Sri Lanka',
  },
  {
    code: 'SD',
    name: 'Sudan',
  },
  {
    code: 'SR',
    name: 'Suriname',
  },
  {
    code: 'SJ',
    name: 'Svalbard and Jan Mayen',
  },
  {
    code: 'SZ',
    name: 'Swaziland',
  },
  {
    code: 'SE',
    name: 'Sweden',
  },
  {
    code: 'CH',
    name: 'Switzerland',
  },
  {
    code: 'SY',
    name: 'Syrian Arab Republic',
  },
  {
    code: 'TW',
    name: 'Taiwan, Province of China',
  },
  {
    code: 'TJ',
    name: 'Tajikistan',
  },
  {
    code: 'TZ',
    name: 'Tanzania, United Republic of',
  },
  {
    code: 'TH',
    name: 'Thailand',
  },
  {
    code: 'TL',
    name: 'Timor-Leste',
  },
  {
    code: 'TG',
    name: 'Togo',
  },
  {
    code: 'TK',
    name: 'Tokelau',
  },
  {
    code: 'TO',
    name: 'Tonga',
  },
  {
    code: 'TT',
    name: 'Trinidad and Tobago',
  },
  {
    code: 'TN',
    name: 'Tunisia',
  },
  {
    code: 'TR',
    name: 'Turkey',
  },
  {
    code: 'TM',
    name: 'Turkmenistan',
  },
  {
    code: 'TC',
    name: 'Turks and Caicos Islands',
  },
  {
    code: 'TV',
    name: 'Tuvalu',
  },
  {
    code: 'UG',
    name: 'Uganda',
  },
  {
    code: 'UA',
    name: 'Ukraine',
  },
  {
    code: 'AE',
    name: 'United Arab Emirates',
  },
  {
    code: 'GB',
    name: 'United Kingdom',
  },
  {
    code: 'US',
    name: 'United States',
  },
  {
    code: 'UM',
    name: 'United States Minor Outlying Islands',
  },
  {
    code: 'UY',
    name: 'Uruguay',
  },
  {
    code: 'UZ',
    name: 'Uzbekistan',
  },
  {
    code: 'VU',
    name: 'Vanuatu',
  },
  {
    code: 'VE',
    name: 'Venezuela, Bolivarian Republic of',
  },
  {
    code: 'VN',
    name: 'Viet Nam',
  },
  {
    code: 'VG',
    name: 'Virgin Islands, British',
  },
  {
    code: 'VI',
    name: 'Virgin Islands, U.S.',
  },
  {
    code: 'WF',
    name: 'Wallis and Futuna',
  },
  {
    code: 'EH',
    name: 'Western Sahara',
  },
  {
    code: 'YE',
    name: 'Yemen',
  },
  {
    code: 'ZM',
    name: 'Zambia',
  },
  {
    code: 'ZW',
    name: 'Zimbabwe',
  },
];
export const myloBaby = [
  3181, 3137, 3129, 1093, 1094, 284, 452, 253, 2048, 2007, 2008, 2654, 909,
  3199, 3228, 907, 2382, 2609, 2608, 790, 3187, 3038, 3037, 2151, 2153, 2149,
  2150, 2998, 2999, 1117, 1065, 1116, 1064, 1068, 1067, 1121, 3005, 3006, 3004,
  3001, 3007, 3000, 3002, 3003, 1125, 1761, 777, 1760, 1759, 1758, 792, 908,
  778, 1932, 1931, 1933, 1930, 1925, 1928, 1929, 1927, 1934, 779, 1926, 2003,
  1383, 1380, 1381, 1124, 1122, 1384, 1123, 1382, 1905, 1914, 1385, 1910, 1913,
  1907, 1386, 1908, 1389, 1387, 1388, 1912, 1911, 1906, 2012, 2478, 2479, 2304,
  2480, 2481, 2469, 2468, 2470, 3131, 3146, 3050, 3044, 3049, 1207, 2167, 2168,
  656, 655, 281, 270, 283, 435, 433, 432, 431, 2876, 2169, 2653, 3198, 3225,
  775, 774, 1691, 1696, 1693, 1697, 1695, 1692, 1694, 2613, 2612, 2611, 2170,
  1879, 791, 3148, 789, 2315, 1877, 3147, 2051, 2906, 1921, 1917, 1922, 1919,
  1918, 1923, 1916, 1924, 1920, 3428, 3393, 3429, 3392, 3397, 3396, 3394, 3430,
  3395, 3214, 3274, 3276, 3272, 3273, 3277, 3275, 3271, 3262, 3231, 3260, 3261,
  450, 969, 505, 506, 968, 508, 966, 507, 970, 967, 504, 1238, 1131, 1241, 1265,
  1260, 1259, 1262, 1267, 1129, 1130, 1127, 1261, 1263, 1239, 1128, 1126, 1240,
  1266, 1264, 975, 1315, 976, 793, 784, 1253, 783, 3423, 3418, 3421, 1257, 1255,
  794, 977, 785, 3420, 788, 3419, 1313, 1314, 1237, 782, 1254, 1256, 1258, 3422,
  3417, 1316, 2177, 1115, 2180, 2181, 352, 1677, 1674, 1678, 1676, 1675, 952,
  1251, 1248, 1249, 1312, 1247, 1250, 1909, 1245, 1246, 807, 810, 808, 809,
  3304, 2006, 2930, 2931, 2932, 2986, 2994, 2987, 3039, 3052, 3053, 851, 857,
  856, 858, 2476, 1097, 2312, 2293, 2307, 2294, 2297, 2309, 2311, 2308, 2310,
  2305, 2295, 2296, 2298, 2292, 2313, 2306, 2477, 3416, 2897, 2436, 2438, 2440,
  2441, 1681, 1120, 1119, 2439, 2437, 884, 881, 885, 882, 883, 485, 2320, 2316,
  2314, 2318, 2317, 2319, 2321, 3432, 3431, 1587, 632, 635, 629, 631, 634, 633,
  630, 626, 1880, 1878, 1768, 1772, 1767, 1771, 1787, 1770, 1769, 1775, 1781,
  1795, 1783, 1793, 1778, 1790, 627, 625, 628, 2190, 2178, 2192, 2179, 800,
  1752, 1753, 1756, 1757, 1755, 1754, 1751, 2176, 6, 1750, 2628, 2629, 2630,
  801, 3208, 3209, 206, 32, 487, 841, 2001, 2002, 2000, 1999, 1915, 2490, 3152,
  2489, 3150, 3151, 2488, 3149, 2491, 2892, 3206, 3204, 3207, 3205, 2632, 2631,
  698, 2343, 2342, 3406, 2881, 3211, 3212, 3210, 2610, 2302, 2303, 3368, 3402,
  3377, 3365, 3352, 3366, 3349, 3359, 3388, 3345, 3363, 3350, 3381, 3403, 3376,
  3343, 3380, 3361, 3348, 3354, 3373, 3378, 3370, 3382, 3356, 3346, 3372, 3404,
  3357, 3353, 3358, 3344, 3367, 3351, 3360, 3362, 3374, 3347, 3355, 3379, 3375,
  3369, 3371, 3364, 3383, 349, 353, 350, 351, 747, 746, 745, 2622, 2621, 2623,
  3215, 3400, 2380, 3184, 2379, 3183, 2378, 3182, 2381, 3185, 2891, 2890, 3399,
  3398, 2397, 2398, 2396, 2893, 2995, 2997, 2996, 2620, 2619, 2625, 2624, 738,
  1286, 2578, 2583, 2579, 2582, 381, 2426, 2009, 2010, 2011, 1762, 478, 1764,
  1763, 2588, 399, 400, 486, 260, 265, 397, 257, 262, 1242, 2896, 2929, 2928,
  274, 273, 491, 1243, 1289, 1288, 1290, 1244, 256, 42, 43, 263, 428, 259, 258,
  1087, 1086, 1438, 7054, 3511, 3687, 3689, 3688,
];
export const myloCare = [
  3186, 2912, 707, 1096, 1965, 3138, 1095, 210, 519, 3160, 729, 2877, 2880,
  2879, 2878, 526, 2446, 1735, 3269, 2387, 2427, 3159, 2207, 898, 1092, 861,
  731, 2322, 3145, 3144, 3143, 1725, 826, 3120, 3162, 3163, 280, 3107, 1252,
  2483, 2482, 211, 455, 825, 1085, 847, 456, 286, 214, 213, 1271, 401, 2171,
  732, 846, 728, 979, 2627, 1088, 978, 2485, 2484, 2651, 730, 1991, 1992, 1993,
  404, 820, 811, 821, 816, 2989, 758, 2344, 1728, 3252, 3253, 2888, 699, 1216,
  1217, 1219, 1218, 2862, 1089, 2183, 2206, 1436, 451, 3119, 3132, 3133, 1090,
  3158, 3157, 2434, 2444, 2348, 2349, 2350, 2352, 2351,
];
export const myloMom = [
  2527, 2571, 2512, 2547, 2563, 2499, 2492, 2503, 2522, 2505, 2529, 2560, 2528,
  2513, 2568, 2509, 2498, 2520, 2497, 2553, 2565, 2552, 2540, 2572, 2569, 2523,
  2516, 2507, 2555, 2515, 2493, 2545, 2550, 2561, 2500, 2518, 2564, 2539, 2566,
  2525, 2511, 2542, 2538, 2574, 2526, 2558, 2541, 2506, 2559, 2531, 2533, 2494,
  2557, 2504, 2573, 2575, 2496, 2549, 2556, 2562, 2534, 2530, 2510, 2524, 2501,
  2535, 2514, 2495, 2551, 2546, 2537, 2532, 2508, 2502, 2519, 2521, 2554, 2548,
  2543, 2570, 2536, 2544, 613, 619, 620, 618, 621, 612, 611, 610, 3412, 3411,
  3410, 3413, 543, 542, 606, 607, 608, 616, 617, 615, 614, 541, 2173, 108, 1823,
  1842, 1841, 1843, 1844, 2174, 2175, 2172, 2189, 2188, 2950, 2956, 2954, 2951,
  2952, 2955, 2953, 2957, 2835, 2836, 2834, 2837, 2964, 2979, 2960, 2973, 2974,
  2856, 2958, 2857, 2975, 2970, 2853, 2981, 2971, 2859, 2855, 2976, 2969, 2967,
  2959, 2978, 2963, 2966, 2852, 2961, 2858, 2962, 2977, 2972, 2965, 2980, 2854,
  2968, 2202, 2205, 2203, 2204, 1830, 1831, 1838, 1835, 1827, 1826, 1824, 1832,
  1829, 1837, 1833, 1825, 1834, 1828, 1836, 1847, 1855, 1850, 1846, 1853, 1849,
  1839, 1856, 1848, 1852, 1845, 1854, 1851, 1858, 1857, 1862, 1860, 1861, 1863,
  1840, 1864, 1859, 1789, 1773, 1784, 1782, 1788, 1796, 1786, 1780, 1779, 1785,
  1791, 1794, 1792, 1776, 1798, 1797, 1777, 1774, 1946, 1952, 1956, 1961, 1947,
  1945, 1950, 1949, 1951, 1943, 1954, 1944, 1939, 1942, 1948, 1938, 1955, 1941,
  1940, 1953, 1958, 1960, 1957, 1959, 1645, 1646, 1643, 1652, 1651, 1659, 1654,
  1658, 1657, 1660, 1656, 1647, 1653, 1649, 1655, 1650, 1644, 1648, 1317, 950,
  946, 932, 1332, 927, 1338, 928, 1356, 1351, 935, 1348, 1349, 910, 951, 934,
  915, 1350, 943, 1357, 944, 1070, 931, 937, 1331, 1336, 1345, 942, 948, 945,
  940, 1339, 1354, 947, 1346, 1340, 917, 1334, 1337, 933, 1358, 925, 941, 939,
  938, 924, 926, 1347, 1341, 929, 930, 1343, 1355, 1020, 1344, 1353, 914, 1333,
  949, 936, 1352, 1342, 1335, 1295, 1297, 1296, 1291, 1307, 1309, 1298, 1293,
  1292, 1304, 1311, 1305, 1302, 1294, 1310, 1300, 1301, 1299, 1306, 1303, 1327,
  1319, 918, 1052, 1042, 1057, 1025, 1026, 1330, 916, 1027, 1326, 1318, 913,
  1041, 1048, 1024, 1040, 1049, 1037, 1047, 1044, 1045, 1035, 1030, 1058, 1031,
  1043, 1054, 1039, 1051, 1056, 921, 1320, 1323, 922, 919, 1021, 1033, 1050,
  1034, 1032, 1028, 911, 923, 1061, 920, 1022, 1029, 1328, 1023, 1038, 1059,
  1053, 912, 1055, 1322, 1060, 1046, 1324, 1325, 1036, 1329, 1321, 1014, 1007,
  1006, 1370, 1364, 1363, 1375, 1005, 1373, 1012, 1010, 1018, 1366, 1367, 1365,
  1362, 1017, 1008, 1015, 1368, 1371, 1016, 1372, 1019, 1013, 1009, 1369, 1374,
  2340, 2334, 2338, 2567, 1308, 2933, 3316, 3325, 3314, 3308, 2901, 3315, 3309,
  3320, 3340, 3332, 3329, 3310, 3317, 3324, 3335, 3341, 2902, 3334, 3306, 3331,
  3319, 3312, 3336, 3323, 3328, 3326, 3307, 3333, 3337, 3339, 2904, 3318, 3327,
  3338, 3313, 2903, 3311, 3330, 3322, 3321, 2259, 2061, 2063, 2258, 2255, 2254,
  2253, 2257, 1971, 1972, 1967, 1969, 1973, 1970, 2067, 2252, 2068, 2256, 2066,
  2062, 2064, 2065, 1974, 1968, 2017, 2026, 2015, 2022, 2018, 2019, 2023, 2021,
  2024, 2016, 2025, 2020, 2028, 2031, 2033, 2032, 2029, 2030, 2949, 2948, 2034,
  2946, 2947, 2027, 2038, 2036, 2040, 2042, 2035, 2039, 2037, 2041, 2073, 2072,
  2071, 2082, 2081, 2079, 2076, 2074, 2077, 2078, 2075, 2080, 2372, 2375, 2374,
  2377, 2370, 2373, 2376, 2371, 2408, 2409, 2411, 2414, 2412, 2416, 2413, 2410,
  2424, 2423, 2419, 2421, 2422, 2418, 2417, 2420, 2849, 2850, 2842, 2845, 2841,
  2847, 2851, 2848, 2846, 2840, 2844, 2843, 2943, 2934, 2939, 2937, 2935, 2945,
  2940, 2941, 2936, 2938, 2942, 2944, 748, 749, 750, 751, 2161, 2165, 2159,
  2155, 2158, 2157, 2164, 2156, 2154, 2162, 2163, 2160, 842, 843, 844, 845,
  2400, 2404, 2403, 2406, 2405, 2402, 2401, 2399, 3035, 3026, 3033, 3028, 3023,
  3018, 3032, 3025, 3031, 3029, 3015, 3034, 3021, 3020, 3014, 3022, 3017, 3019,
  3024, 3030, 3013, 3027, 3012, 1806, 1799, 1800, 3016, 1803, 1801, 1804, 1802,
  1809, 1807, 1811, 1815, 1812, 1814, 1813, 1808, 1810, 1816, 1805, 3070, 3067,
  3068, 3065, 3066, 3072, 3059, 3060, 3069, 3057, 3056, 3071, 3062, 3064, 3058,
  3061, 3073, 3063, 2636, 2648, 2639, 2640, 2650, 2642, 2633, 2643, 2637, 2638,
  2645, 2635, 2634, 2644, 2646, 2649, 2641, 2647, 853, 854, 852, 11, 1817, 1818,
  1822, 1821, 1819, 1820, 1699, 1700, 1698, 2234, 2226, 2232, 2236, 2230, 2225,
  2229, 2235, 2231, 2227, 2228, 2233, 2237, 2245, 2238, 2244, 2241, 2239, 2242,
  2248, 2246, 2240, 2247, 2243, 2215, 2222, 2224, 2214, 2218, 2219, 2220, 2221,
  2213, 2223, 2217, 2216, 1534, 1530, 1535, 1537, 1539, 1528, 1531, 1526, 1524,
  1536, 1538, 1540, 1527, 1523, 1533, 1532, 1529, 1525, 1516, 1512, 1505, 1509,
  1519, 1522, 1506, 1507, 1513, 1521, 1508, 1510, 1520, 1511, 1518, 1517, 1515,
  1514, 2517, 2197, 2199, 2201, 2200, 2198, 2195, 2194, 2196,
];

export const getBrandName = (productId) => {
  const foundInBaby =
    myloBaby.find((element) => element == productId) ||
    myloMom.find((element) => element == productId);
  if (foundInBaby) return 'Mylo Baby';
  return 'Mylo Care';
};

export const first10OfferData = [
  {
    term_id: 6013,
    term: '10% Off - FIRST 10',
    parent_id: 4963,
    is_functional: 1,
    name: 'Extra 10% Off',
    description: 'Extra 10% Off on your first Mylo Order',
    meta_description: 'EXTRA 10% Off',
    hindi_description: 'Extra 10% Off on your first Mylo Order',
    hindi_meta_description: 'EXTRA 10% Off',
    color: '#000000',
    offer_id: 427,
    name_hi: 'Extra 10% Off',
    value_type: '2',
    value_json: '{"percentage":10,"action":"price"}',
    max_discount_price: 1500,
    min_num_limit: 1,
    max_num_limit: 999,
    validity_type: '3',
    validity: 30,
    repeat_count: 5,
    payment_mode: '0',
    cart_min_amount: 99,
    cart_max_amount: 99999,
    start_date: '2022-04-21T14:13:03.000Z',
    end_date: '2024-09-28T06:00:00.000Z',
    stage: 'mother,pregnant,ttc',
    level: '3',
    priority: 30,
    platform: '2',
    product_ids:
      '108,210,211,213,214,253,258,280,281,283,284,286,349,350,351,352,353,381,382,401,404,428,450,451,456,478,485,511,512,519,520,521,524,525,526,541,542,543,602,603,625,627,699,701,707,728,729,730,731,732,743,744,745,746,747,748,749,750,751,760,763,764,765,766,767,768,769,770,771,777,778,779,780,785,788,789,790,791,792,793,794,800,816,820,821,824,826,831,832,834,842,843,844,845,846,847,852,853,854,856,857,858,860,861,862,881,897,898,907,908,963,975,976,977,978,979,1005,1006,1007,1008,1010,1012,1013,1014,1015,1016,1017,1018,1019,1020,1021,1022,1023,1024,1025,1026,1027,1028,1029,1030,1032,1033,1034,1035,1036,1037,1038,1039,1040,1041,1042,1043,1044,1045,1046,1047,1048,1049,1050,1051,1052,1053,1054,1055,1056,1057,1058,1059,1060,1061,1090,1091,1095,1115,1122,1123,1124,1125,1126,1127,1128,1129,1130,1131,1207,1216,1217,1218,1219,1237,1239,1242,1243,1244,1253,1254,1255,1256,1257,1258,1259,1260,1261,1262,1263,1264,1265,1266,1267,1288,1289,1290,1313,1314,1315,1316,1362,1363,1364,1365,1366,1367,1368,1369,1370,1372,1373,1435,1587,1625,1626,1627,1631,1642,1673,1674,1675,1676,1677,1678,1702,1703,1704,1705,1706,1708,1725,1735,1756,1767,1768,1769,1770,1771,1772,1774,1775,1776,1777,1778,1779,1780,1781,1782,1783,1784,1785,1786,1787,1788,1789,1790,1791,1792,1793,1794,1795,1796,1797,1798,1799,1800,1801,1802,1803,1804,1805,1806,1807,1808,1809,1810,1811,1812,1813,1814,1815,1816,1817,1818,1819,1820,1821,1822,1823,1824,1826,1829,1830,1831,1832,1833,1834,1841,1842,1844,1940,1941,1942,1943,1944,1945,1946,1947,1948,1949,1951,1952,1953,1954,1955,1965,2007,2008,2169,2171,2176,6,2178,2179,1092,2006,487,604,605,626,628,761,762,801,882,883,884,1700,1760,1761,964,523,825,885,1003,1031,1094,1374,1375,1707,1709,1710,1758,1773,1827,1828,1835,1836,1837,1838,1839,1840,1961,2192,2342,2343,698,1009,1960,2316,2317,2318,2319,2320,2321,1089,1096,2001,2002,2167,2168,2173,2174,2188,2189,2194,2195,2196,2197,2198,2199,2200,2201,2202,2203,2204,2205,2292,2293,2294,2295,2296,2297,2298,2306,2307,2308,2309,2310,2311,2312,2313,851,2009,2010,2011,2348,2349,2350,2437,2351,2352,758,1088,1097,1938,1939,1950,1956,1957,1958,1959,1724,2172,2175,2207,2378,2379,2380,2381,2396,2397,2398,2426,2434,2436,2438,2439,2444,2476,2477,2489,2490,2491,2577,2581,2583,2584,2588,69,443,655,850,2059,2117,2118,2119,2120,2121,2122,2123,2124,2125,2126,2127,2128,2180,2181,2206,2305,2322,2425,2440,2441,2617,2621,2622,2623,2624,2625,2628,2629,2630,2663,2664,2665,2666,2668,2670,2671,2672,2673,2676,2677,2678,2681,2682,2683,2684,2685,2686,2692,2694,2695,2696,2697,2698,2699,2700,2701,2702,2706,2707,2708,2733,2734,2735,2736,2737,2738,2746,2748,2749,2751,2752,2753,2754,2755,2834,2835,2836,2837,2890,2891,2892,2893,2896,2928,2929,2950,2951,2952,2953,2954,2955,2956,2957,2958,2959,2960,2961,2966,2967,2968,2969,2986,2987,2994,3053,2446,2610,2611,2612,2613,2711,2712,2713,2714,2721,2722,2723,2724,2725,2726,2852,2853,2854,2855,2856,2857,2858,2859,2877,2879,2880,2962,2963,2964,2965,2970,2971,2972,2973,2974,2975,2976,2977,2978,2979,2980,2981,2989,3008,3039,3056,3057,3058,3059,3060,3061,3062,3063,3064,3065,3066,3067,3068,3069,3070,3071,3072,3073,3119,3132,3133,3143,3144,3145,3147,3148,3159,3162,3164,3187,3231,3252,3253,3269,3499,3500,3501,3184,3183,3185,3502,3503,3504,3505,3506,3507,3197,3407,3408,3434,3433,2653,2876,2916,3046,3229,3230,3232,3233,3234,3235,3236,3246,3247,3248,3249,3250,3251,3263,3264,3265,3266,3267,3268,3392,3394,3395,3396,3397,3426,3427,3429,3430,3454,3525,3530,3534,3538,3662,3663',
    offer_heading: 'WELCOME OFFER',
    code: 'FIRST10',
  },
];

export const getExperimentalOfferData = (
  productId,
  offerData = [],
  userType,
) => {
  // if (productId.includes("979") && userType === "B") {
  // return [...first10OfferData, ...offerData];
  // }
  return offerData;
};
export const getBrowserId = () => {
  if (Cookies.get('browser_id')) {
    return Cookies.get('browser_id');
  } else {
    const browser_id = uuidv4();
    Cookies.set('browser_id', browser_id, '/');
    return browser_id;
  }
};
export const getRandomExperimentValue = () => {
  const randomValue = Math.random();
  return randomValue <= 0.33 ? 'A' : randomValue <= 0.67 ? 'B' : 'C';
};
export const getExperimentTypeOfUser = () => {
  let experiment_type = '';
  if (!Cookies.get('experiment_type')) {
    experiment_type = getRandomExperimentValue();

    Cookies.set('experiment_type', experiment_type, '/');
  }
  return Cookies.get('experiment_type');
};

export function getQueryStrings(url) {
  let queryString = url;
  let assoc = {};
  let decode = (s) => {
    return decodeURIComponent(s.replace(/\+/g, ' '));
  };

  let keyValues = queryString.split('&');

  for (const i in keyValues) {
    const key = keyValues[i].split('=');
    if (key.length > 1) {
      assoc[decode(key[0])] = decode(key[1]);
    }
  }

  return assoc;
}

export function getSearchQueryParamsWithAD() {
  try {
    const queryParams = window?.location?.search || '';
    if (queryParams.length > 0) {
      let newQueryParams = getQueryStrings(queryParams.replace('?', ''));
      let ad_params = '';
      if (newQueryParams?.AdsetID)
        ad_params = ad_params + 'AdsetID=' + newQueryParams?.AdsetID;
      if (newQueryParams?.AdID)
        ad_params = ad_params + '&AdID=' + newQueryParams?.AdID;
      if (newQueryParams?.ad_id)
        ad_params = ad_params + '&ad_id=' + newQueryParams?.ad_id;
      if (newQueryParams?.adset_id)
        ad_params = ad_params + '&adset_id=' + newQueryParams?.adset_id;
      if (newQueryParams?.campaign_id)
        ad_params = ad_params + '&campaign_id=' + newQueryParams?.campaign_id;

      return ad_params;
    } else {
      return '';
    }
  } catch (error) {
    // console.log("getSearchQueryParamsWithAD", error);
    return '';
  }
}

export function removeAdQueryParams(url) {
  try {
    let oldUrl = url;
    if (oldUrl.length > 0) {
      let newQueryParams = getQueryStrings(oldUrl.replace('?', ''));
      // if ("Campaign" in newQueryParams) delete newQueryParams["Campaign"];
      if ('AdsetID' in newQueryParams) delete newQueryParams['AdsetID'];
      if ('AdID' in newQueryParams) delete newQueryParams['AdID'];
      // fbclid is not required in any analytics as discussed to removing this as well
      if ('fbclid' in newQueryParams) delete newQueryParams['fbclid'];
      if ('firstPage' in newQueryParams) delete newQueryParams['firstPage'];
      if (
        ('inExpert' in newQueryParams || 'epid' in newQueryParams) &&
        'id' in newQueryParams
      )
        delete newQueryParams['id'];
      // if ("inExpert" in newQueryParams) delete newQueryParams["id"];
      if ('epid' in newQueryParams) delete newQueryParams['epid'];
      let newUrl =
        '?' +
        Object.keys(newQueryParams)
          .map((key) => key + '=' + newQueryParams[key])
          .join('&');
      return newUrl;
    } else {
      return oldUrl;
    }
  } catch (error) {
    // console.log("getSearchQueryParamsWithAD", error);
    return url;
  }
}

export function getSearchQueryParamsWithoutAD() {
  const source = 'utm_source';
  const campaign = 'utm_campaign';
  const medium = 'utm_medium';
  const content = 'utm_content';
  const term = 'utm_term';
  let queryParams = {};
  if (typeof window !== 'undefined') {
    queryParams = window?.location?.search || '';
  }
  if (queryParams.length > 0) {
    let newQueryParams = removeAdQueryParams(queryParams);
    newQueryParams = newQueryParams
      .replace(source, 's')
      .replace(campaign, 'cm')
      .replace(medium, 'm')
      .replace(content, 'c')
      .replace(term, 't');
    if (newQueryParams.length > 99) {
      newQueryParams = newQueryParams.substring(0, 99);
    }
    return newQueryParams;
  } else {
    return 'NA';
  }
}

export const getWebUserId = () =>
  Cookies.get('web_user_id_react') ? Cookies.get('web_user_id_react') : null;

export const getCartItemsCookie = () => {
  return Cookies.get('cart_items');
};
export const getNicknameAndUrl = (cartData) => {
  let productDetails = { nickName: '', productUrl: '' };
  let offeredProduct = cartData?.cart_products?.[0]?.offered_product;
  let productArray = cartData?.cart_products;

  if (offeredProduct) {
    productDetails['nickName'] = getProductname(
      productArray[0]?.offered_product?.[0],
    );
    productDetails['productUrl'] =
      productArray[0]?.offered_product?.[0]?.images?.[0];
  } else {
    productDetails['nickName'] = getProductname(productArray?.[0]);
    productDetails['productUrl'] = productArray?.[0]?.images?.[0];
  }
  return productDetails;
};

const getProductname = (product) => {
  return product?.nickname
    ? checkProductLength(product?.nickname)
    : checkProductLength(product?.name);
};
